export default __webpack_public_path__ + "static/media/1822.7effaa8f.png";